<template>
	<sf-data-table
		ref="pqyCpnyTable"
		:pageUnit="pageUnit_"
		:totalSize="totalSize_"
		paging
		:columns="columns"
		:rows="pqyCpnyList"
		:stripe="false"
		:selection="true"
		@changedPage="changedPage"
		index
		height="50vh"
	>
		<template v-slot:actionsLeft>
			<!-- 선택 -->
			<sf-button line icon="square-plue" :onClick="selUsers">
				{{ getMessage_('QWCC001476') }}
			</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/PqyCpnyPopup/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					label: this.getMessage_('QWCC001108'), //업체구분
					prop: 'cpnyScn',
					minWidth: '1px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC000950'), //업체코드
					prop: 'cpnyCd',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC000951'), //업체명
					prop: 'cpnyNm',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC000059'), //부품유형
					prop: 'partType',
					minWidth: '1px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001593'), //업체담당자
					prop: 'crgrNm',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001474'), //전화번호
					prop: 'crgrTn',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('SWCC000406'), //이메일
					prop: 'eml',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC000060'), //FAX번호
					prop: 'fax',
					minWidth: '1px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001162'), //지역
					prop: 'regn',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001164'), //주소
					prop: 'adr',
					minWidth: '150px',
					sortable: false
				}
			];
		}
	},
	mounted() {},
	methods: {
		...rootMethods,
		...serviceMethods,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('reload', currentPageVal, pageUnitVal);
		},
		selUsers(row) {
			// userGbn은 하나의 Form에 사용자 찾기가 2건이 필요할 경우 해당 값을 셋팅한다.
			const selectedRows = this.$refs.pqyCpnyTable.getSelectedRows();
			if (selectedRows.length === 0) {
				const errMsg = this.getMessage_('QWCC001716'); //한가지 업체만 선택해 주시기 바랍니다.
				this.$sf_toast({ type: 'error', message: errMsg, option: { duration: 3000 } });
				return;
			} else {
				this.$emit('SendData', selectedRows);
			}
		}
	}
};
</script>

<style></style>
